import React, { useEffect, useState } from 'react';
import { AdminLayout } from './AdminLayout';
import { supabase } from '../../services/supabase';
import { ShieldAlert, Trash2 } from 'lucide-react';

export const AdminBlockedStrategies: React.FC = () => {
    const [strategies, setStrategies] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [newId, setNewId] = useState('');

    useEffect(() => {
        fetchBlocked();
    }, []);

    const fetchBlocked = async () => {
        const { data } = await supabase.from('blocked_strategies').select('*').order('blocked_at', { ascending: false });
        if (data) setStrategies(data);
        setLoading(false);
    };

    const blockStrategy = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!newId) return;
        await supabase.from('blocked_strategies').insert([{ strategy_id: newId, strategy_name: 'Manually Blocked' }]);
        setNewId('');
        fetchBlocked();
    };

    const unblockStrategy = async (id: string) => {
        await supabase.from('blocked_strategies').delete().eq('id', id);
        fetchBlocked();
    };

    return (
        <AdminLayout>
            <div className="mb-6">
                <h1 className="text-3xl font-bold text-white mb-2">Blocked Strategies</h1>
                <p className="text-gray-400">Prevent specific strategy IDs from generating live signals.</p>
            </div>

            <div className="bg-finance-card border border-gray-800 rounded-xl p-6 mb-8">
                <form onSubmit={blockStrategy} className="flex gap-4">
                    <input
                        type="text"
                        value={newId}
                        onChange={(e) => setNewId(e.target.value)}
                        placeholder="Enter Strategy ID (e.g. ST2207)"
                        className="flex-1 bg-gray-900 border border-gray-700 rounded-lg px-4 py-2 text-white placeholder-gray-500 focus:outline-none focus:border-finance-accent"
                    />
                    <button type="submit" className="bg-red-500 hover:bg-red-600 text-white font-bold py-2 px-6 rounded-lg flex items-center gap-2 transition-colors">
                        <ShieldAlert className="w-5 h-5" />
                        Block Strategy
                    </button>
                </form>
            </div>

            <div className="bg-finance-card border border-gray-800 rounded-xl overflow-hidden">
                <table className="w-full text-left text-sm text-gray-400">
                    <thead className="bg-gray-800/50 text-gray-300">
                        <tr>
                            <th className="px-6 py-4 font-medium">Strategy ID</th>
                            <th className="px-6 py-4 font-medium">Name</th>
                            <th className="px-6 py-4 font-medium">Blocked At</th>
                            <th className="px-6 py-4 font-medium">Action</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-800">
                        {loading ? (
                            <tr><td colSpan={4} className="px-6 py-8 text-center">Loading...</td></tr>
                        ) : strategies.length === 0 ? (
                            <tr><td colSpan={4} className="px-6 py-8 text-center">No blocked strategies.</td></tr>
                        ) : (
                            strategies.map((st) => (
                                <tr key={st.id} className="hover:bg-gray-800/20 transition-colors">
                                    <td className="px-6 py-4 font-medium text-white">{st.strategy_id}</td>
                                    <td className="px-6 py-4">{st.strategy_name}</td>
                                    <td className="px-6 py-4">{new Date(st.blocked_at).toLocaleString()}</td>
                                    <td className="px-6 py-4">
                                        <button onClick={() => unblockStrategy(st.id)} className="text-emerald-400 hover:text-emerald-300 font-medium flex items-center gap-1">
                                            <Trash2 className="w-4 h-4" /> Unblock
                                        </button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </AdminLayout>
    );
};
